import InvoiceConfigsModal from './InvoiceConfigsModal'
import React from 'react'
import InvoiceCustomerDataModal from './InvoiceCustomerDataModal'

const InvoiceModals = React.memo(({
	invoiceConfigsModalIsOpen, closeInvoiceConfigsModal, submitInvoiceConfig,
	invoiceCustomerDataModalIsOpen, closeInvoiceCustomerDataModal, onSubmit,
	captureCustomerData = false, paidOrderMode = false, customer = null,
}) => {
	return (
		<>
			<InvoiceConfigsModal isOpen={invoiceConfigsModalIsOpen}
													 close={closeInvoiceConfigsModal}
													 onSubmitData={submitInvoiceConfig} />

			<InvoiceCustomerDataModal isOpen={invoiceCustomerDataModalIsOpen}
																close={closeInvoiceCustomerDataModal}
																onSubmit={onSubmit}
																captureCustomerData={captureCustomerData}
																paidOrderMode={paidOrderMode}
																customer={customer} />
		</>

	)
})

InvoiceModals.displayName = 'InvoiceModals'
export default InvoiceModals
